const FILE_TYPES = {
    CSV: '.csv',
    MS_EXCEL_BINARY: '.xls',
    MS_EXCEL: '.xlsx',
};
export const spreadsheetFileTypes = [
    FILE_TYPES.CSV,
    FILE_TYPES.MS_EXCEL,
    FILE_TYPES.MS_EXCEL_BINARY,
];
export default FILE_TYPES;
